import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { Icon } from '@noths/polaris-design-system-core-components';

import * as copy from 'src/components/organisms/ProductInformation/constants/copy';
import { removeHtmlElementsFromString } from 'src/utils/removeHtmlElementFromString';
import * as styles from './ProductInformation.style';

export interface ProductInformationProps {
  dimensions?: string;
  ingredientsFileURLPath?: string;
  materials?: string;
  onVisible: () => void;
  otherInformation: string;
  productCode: number;
  variationsAvailable?: string;
}

interface SectionProps {
  heading: string;
  html: string;
}

const Section = ({ heading, html }: SectionProps) => {
  return (
    <>
      <h2 css={styles.heading}>{heading}</h2>
      <div
        dangerouslySetInnerHTML={{
          __html: removeHtmlElementsFromString(html, ['b', 'strong']),
        }}
      />
    </>
  );
};

export const ProductInformation = ({
  dimensions,
  ingredientsFileURLPath,
  materials,
  onVisible,
  otherInformation,
  productCode,
  variationsAvailable,
}: ProductInformationProps) => {
  const rootRef = useImpressionRef<HTMLDivElement>(() => onVisible());

  return (
    <div css={styles.wrapper} ref={rootRef}>
      <div css={styles.content}>
        <Section heading={copy.PRODUCT_DESCRIPTION_HEADING} html={otherInformation} />
        {variationsAvailable && (
          <Section heading={copy.PRODUCT_VARIATIONS_HEADING} html={variationsAvailable} />
        )}
      </div>
      <div css={styles.content}>
        {materials && <Section heading={copy.MADE_FROM_HEADING} html={materials} />}
        {dimensions && <Section heading={copy.PRODUCT_DIMENTIONS_HEADING} html={dimensions} />}
        {ingredientsFileURLPath && (
          <div css={styles.ingredientsInfo}>
            <div css={[styles.fileLinkWrapper]}>
              <Icon css={styles.fileIcon} name="document" size="sm" />
              <a
                css={styles.fileLink}
                href={`https://cdn.notonthehighstreet.com${ingredientsFileURLPath}`}
                rel="noreferrer"
                target="_blank"
              >
                {copy.INGREDIENTS_TITLE}
              </a>
            </div>
          </div>
        )}
        <Section heading={copy.PRODUCT_CODE_HEADING} html={`<p>${productCode}</p>`} />
      </div>
    </div>
  );
};
